import React, { useContext } from "react";

import { MyBetsBetContext } from "@state/context/my-bets/MyBetsBetContext";

export default function BetItemHeaderTableType() {
	const bet = useContext(MyBetsBetContext);

	return <>{bet.formattedBetSystemString}</>;
}
